module.exports = __webpack_public_path__ + "static/img/deposit_none2.00ef993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deposit_none2.svg
// module id = 71Ez
// module chunks = 1